import Axios from "axios";
import Utils from "@utils";

const { appService } = window as any;

const apiClient = Axios.create({
  baseURL: appService.base,
  headers: {
    "Content-Type": "application/json",
  },
});

apiClient.interceptors.request.use((config) => {
  const params = Utils.getUrlParams();
  const token = params.get("token") || "";
  config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default apiClient;

export const getUserId = (): string => {
  const params = Utils.getUrlParams();
  return params.get("p_id_usuario") || "0";
};
